export enum MitarbeiterRoutes {
  BSP_BUERGSCHAFT_UNTERNEHMEN_ZUORDNEN = 'bsp-buergschaft-unternehmen-zuordnen',
  BSP_BUERGSCHAFT_UNTERNEHMEN_ZUORDNEN_UNTERNEHMENSROLLE_AUSWAHL = 'bsp-buergschaft-unternehmen-zuordnen-unternehmensrolle-auswahl',
  BSP_BUERGSCHAFT_UNTERNEHMEN_ZUORDNEN_UNTERNEHMEN_AUSWAHL = 'bsp-buergschaft-unternehmen-zuordnen-unternehmen-auswahl',
  BSP_BUERGSCHAFT_UNTERNEHMEN_ZUORDNEN_DATEN_PRUEFEN = 'bsp-buergschaft-unternehmen-zuordnen-daten-pruefen',

  TL_STAMMDATEN_TEILNEHMER_PREISMODELL_BEARBEITEN = 'trustlog-stammdaten-teilnehmer-preismodell-bearbeiten',

  TL_STAMMDATEN_LISTE = 'stammdatenUnternehmenÜbersichtTrustlog',
}
